<template>
  <div
    class="main"
    v-loading.fullscreen.lock="loading"
    :element-loading-text="$t('loading')"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <div class="main-content" v-if="!loading">
      <Content></Content>
      <!-- <Nav></Nav> -->
    </div>
  </div>
</template>

<script>
import Content from '../layout/contentInfo/content.vue'
import Nav from '../layout/contentInfo/nav.vue'
import { getAccessToken } from '@/utils/userInfo'
import Cookies from 'js-cookie'

export default {
  components: { Content, Nav },
  computed: {
    haveToken () {
      let token = getAccessToken()
      let result = false
      if (token && token !== 'null' && token !== 'undefind' && token !== '') {
        result = true
      }
      return result
    }
  },
  data () {
    return {
      loading: false
    }
  },
  created () {
    if (this.haveToken) {
      Promise.all([this.getUserInfo()]).finally(() => {
        this.loading = false
      })
    } else {
      this.loading = false
    }
  },
  methods: {
    getUserInfo () {
      return this.$http
        .get('/front/consumer/usercenter/custUserCenterInfo', {
          params: {
            appCode: 'PLANTMATE_OFFICIAL',
            companyId: this.$store.state.user.defaultCompanyId + '' || ''
          }
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$store.dispatch(
            'companyList',
            res.data.companyAccountInfo || []
          )
          this.$store.dispatch('setUserInfo', res.data.userInfo)
          Cookies.set('userId', res.data.userInfo.userId)
          Cookies.set('mobile', res.data.userInfo.mobile)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  .main-content {
    min-width: 1500px;
  }
}
</style>
